import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-black mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          
          <h1 className="font-nouvel text-4xl font-bold mb-8">Datenschutzerklärung</h1>
          
          <div className="prose prose-lg max-w-none font-read">
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">1. Datenschutz auf einen Blick</h2>
            
            <h3 className="font-nouvel text-xl font-bold mt-6 mb-3">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
            
            <h3 className="font-nouvel text-xl font-bold mt-6 mb-3">Datenerfassung auf dieser Website</h3>
            <p>
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen 
              Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">2. Hosting</h2>
            <p>
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser 
              Website erfasst werden, werden auf den Servern des Hosters gespeichert.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            
            <h3 className="font-nouvel text-xl font-bold mt-6 mb-3">Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
              Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen 
              Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            
            <h3 className="font-nouvel text-xl font-bold mt-6 mb-3">Hinweis zur verantwortlichen Stelle</h3>
            <p>
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
              Auto Thurm<br />
              Inhaber: Tobias Thurm<br />
              Wildenreuth A 55<br />
              92681 Erbendorf<br /><br />
              Telefon: 09682 722<br />
              E-Mail: info@auto-thurm.de
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">4. Datenerfassung auf dieser Website</h2>
            
            <h3 className="font-nouvel text-xl font-bold mt-6 mb-3">Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
              Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
              der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben 
              wir nicht ohne Ihre Einwilligung weiter.
            </p>
            
            <h3 className="font-nouvel text-xl font-bold mt-6 mb-3">Terminbuchung</h3>
            <p>
              Bei der Buchung eines Werkstatttermins werden folgende Daten erfasst:
            </p>
            <ul className="list-disc pl-6">
              <li>Name und Kontaktdaten</li>
              <li>Fahrzeugdaten (VIN, Kilometerstand)</li>
              <li>Serviceart und Wunschtermin</li>
              <li>Optional: Fotos des Fahrzeugs</li>
            </ul>
            <p>
              Diese Daten werden ausschließlich zur Terminbearbeitung verwendet und nach Abschluss 
              des Services gemäß den gesetzlichen Aufbewahrungsfristen gespeichert.
            </p>
            
            <h3 className="font-nouvel text-xl font-bold mt-6 mb-3">Reifeneinlagerung</h3>
            <p>
              Bei der Einlagerung von Reifen speichern wir:
            </p>
            <ul className="list-disc pl-6">
              <li>Fahrzeug-Kennzeichen</li>
              <li>Reifendaten (Größe, Marke, Profiltiefe)</li>
              <li>Lagerort und Einlagerungsdatum</li>
            </ul>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">5. E-Mail-Kommunikation</h2>
            <p>
              Für den Versand von E-Mails (Terminbestätigungen, Kontaktanfragen) nutzen wir den 
              Dienst Resend. Die E-Mail-Adressen werden ausschließlich für den vorgesehenen Zweck 
              verwendet und nicht an Dritte weitergegeben.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">6. Ihre Rechte</h2>
            <p>Sie haben jederzeit das Recht:</p>
            <ul className="list-disc pl-6">
              <li>Auskunft über Ihre gespeicherten Daten zu erhalten</li>
              <li>Berichtigung unrichtiger Daten zu verlangen</li>
              <li>Löschung Ihrer Daten zu verlangen</li>
              <li>Einschränkung der Verarbeitung zu verlangen</li>
              <li>Der Verarbeitung zu widersprechen</li>
              <li>Datenübertragbarkeit zu verlangen</li>
            </ul>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">7. SSL-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung. Eine verschlüsselte 
              Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf 
              "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
            
            <div className="mt-12 p-4 bg-yellow-50 border-l-4 border-[#EFDF00]">
              <p className="text-sm text-gray-600">
                <strong>Hinweis:</strong> Bitte lassen Sie diese Datenschutzerklärung von einem 
                Rechtsanwalt prüfen und an Ihre spezifischen Geschäftsprozesse anpassen.
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default DatenschutzPage;
